import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { useEventType } from 'features/event_type_provider';
import { useETEditorViewportOffset } from '../../../../hooks';
export const COLOR_OPTIONS = {
  '#ff4f00': 'red',
  '#ff758e': 'light_pink',
  '#e55cff': 'magenta',
  '#8247f5': 'violet',
  '#0099ff': 'blue',
  '#0ae8f0': 'cyan',
  '#17e885': 'lime_green',
  '#ccf000': 'electric_lime',
  '#f8e436': 'bright_yellow',
  '#ffa600': 'orange'
};
const containerCss = "c2z2z6u";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const styledButtonIsDisabledCss = "s1pzpver";
const styledButtonCss = "s18q4xa5";
const StyledButton = forwardRef((props, ref) => {
  const {
    isDisabled,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(styledButtonCss, {
    [styledButtonIsDisabledCss]: isDisabled
  }, props.className)} />;
});

// i18n-tasks-use t('publisher.event_types.color.red')
// i18n-tasks-use t('publisher.event_types.color.light_pink')
// i18n-tasks-use t('publisher.event_types.color.magenta')
// i18n-tasks-use t('publisher.event_types.color.violet')
// i18n-tasks-use t('publisher.event_types.color.blue')
// i18n-tasks-use t('publisher.event_types.color.cyan')
// i18n-tasks-use t('publisher.event_types.color.lime_green')
// i18n-tasks-use t('publisher.event_types.color.electric_lime')
// i18n-tasks-use t('publisher.event_types.color.bright_yellow')
// i18n-tasks-use t('publisher.event_types.color.orange')
const markerCss = "mc9uws";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const style = {
    backgroundColor: color
  };
  const colorKey = COLOR_OPTIONS[color];
  const title = colorKey ? I18n.t(`publisher.event_types.color.${colorKey}`) : '';
  return <Component ref={ref} {...restProps} style={style} title={title} className={classNames(markerCss, props.className)} />;
});
export const ColorPicker = ({
  isLocked,
  showChevron,
  onSelect
}) => {
  const eventType = useEventType();
  const viewportOffset = useETEditorViewportOffset();
  const [toggle, Dropdown, isOpen] = useDropdown();
  const [{
    value: colorValue
  }, _, {
    setValue: setColorValue
  }] = useFormField({
    name: 'color'
  });
  const availableColors = isLocked ? [eventType.color].filter(Boolean) : Object.keys(COLOR_OPTIONS);
  const clickable = !isLocked;
  const selectColor = selectedColor => {
    toggle();
    setColorValue(selectedColor);
    if (onSelect) onSelect();
  };
  return <Container id="color-field">
      <StyledButton aria-label={I18n.t('publisher.event_types.general.event_color')} aria-expanded={isOpen} onClick={toggle} disabled={!clickable}>
        <Marker color={colorValue} />
        {showChevron && (isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />)}
      </StyledButton>
      <Dropdown>
        <ViewportDropdownMenu pullRight fullWidth viewportOffset={viewportOffset}>
          {availableColors.map(color => {
          const colorKey = COLOR_OPTIONS[color];
          if (!colorKey) return null;
          return <Item key={color} onClick={() => selectColor(color)}>
                <Marker color={color} />
                {I18n.t(`publisher.event_types.color.${colorKey}`)}
              </Item>;
        })}
        </ViewportDropdownMenu>
      </Dropdown>
    </Container>;
};

require("./color_picker.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./color_picker.js");